module.exports = __webpack_public_path__ + "img/sun.bc8acb8e.png";